<template>
    <div>
        <div v-if="bill.state === 'COMPLETED'">
            <h3 class="text-5 text-center mb-3">Gift Card Purchase Receipt</h3>
            <div class="text-center mb-3">
                <img class="w-100"
                     :style="{ aspectRatio: `${bill.gift_type.width}/${bill.gift_type.height}`  }"
                     :src="bill.gift_type.image" alt="">
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-right mb-0 mb-sm-3">Gift Card : </p>
                <p class="col-sm-6">
                    <strong>{{ bill.gift_type.name }}</strong><br>
                </p>
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-right mb-0 mb-sm-3">Transaction Reference : </p>
                <p class="col-sm-6">
                    <strong>{{ transaction.customer_reference }}</strong><br>
                </p>
            </div>

            <div class="row" v-if="bill.message">
                <p class="col-sm-6 text-muted text-sm-right mb-0 mb-sm-3">Message : </p>
                <p class="col-sm-6"><strong>{{ bill.message }}</strong></p>
            </div>

            <div v-if="transaction.payment === 'stripe' && bill.currency !== 'USD'" class="row">
                <p class="col-sm-6 text-muted text-sm-right mb-0 mb-sm-3">Bonus : </p>
                <p class="col-sm-6"><strong>You have being awarded a promotional bonus airtime of ZWG
                    {{ bill.rated_amount * this.rate }}</strong></p>
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-right mb-0 mb-sm-3">Recipient : </p>
                <p class="col-sm-6">
                    <strong>{{ bill.phone || bill.email }}</strong>
                    <span v-if="transaction.sms && transaction.sms.delivered" class="badge badge-success">Delivered</span>
                    <span v-else class="badge badge-warning">Pending Delivery</span>
                </p>
            </div>

            <div class="row">
                <p class="col-sm-6 text-muted text-sm-right mb-0 mb-sm-3">Amount : </p>
                <p class="col-sm-6">
                    <strong>ZWG {{ money(bill.gift_type.zwl_price) }}</strong>
                </p>
            </div>

            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-6 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-6 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>

            <div class="form-group mt-5">
                <button @click="submit" :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">Refresh
                </button>
            </div>
        </div>
        <div v-if="bill.state === 'PENDING-PAYMENT'">
            <h3 class="text-5 text-center mb-5">Awaiting Payment </h3>
            <div
                class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
            <p v-if="countDown > 0" class="text-center text-primary text-8 line-height-07 mb-5">
                {{ this.countDown }}
            </p>
            <p class="text-center text-4 mb-5">Waiting for you to complete your payment</p>
            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
            <div class="form-group">
                <button @click="submit" :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">Refresh
                </button>
            </div>
        </div>
        <div v-if="init || bill.state === 'GENERATING-AIRTIME'">
            <h3 class="text-5 text-center mb-5">Purchasing Gift Card ... </h3>
            <div
                class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
            <p v-if="countDown > 0" class="text-center text-primary text-8 line-height-07 mb-5">
                {{ this.countDown }}
            </p>
            <p class="text-center text-4 mb-5">Your Payment was successful we are preparing your Gift Card</p>
            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
            <div class="form-group">
                <button @click="submit" :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">Refresh
                </button>
            </div>
        </div>
        <div v-if="bill.state === 'AIRTIME-FAILED'">
            <h3 class="text-5 text-center mb-5">Gift Card Purchase Receipt</h3>

            <p class="text-center text-4 mb-5">
                Oops! Looks like the Gift Card system is a little unstable right now and your recharge may take longer
                to
                be delivered. You do not have to do anything. You will receive the recharge as soon as it becomes
                available. This usually takes at most 1 hour. Contact Magetsi Support if you need any assistance.
            </p>

            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Ref : </p>
                <p class="col-sm-8 font-weight-500">{{ transaction.customer_reference }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-8 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>

            <p v-if="" class="text-center text-1">To quickly check progress click below.</p>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <button @click.prevent="submit"
                                :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">Refresh
                        </button>
                    </div>
                    <div class="col-md-6">
                        <router-link to="/gift-cards" class="btn btn-outline-primary btn-block">Close</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {money} from "../../../core/forms/money";

export default {
    name: "ecocash.vue",
    mixins: [money],
    data() {
        return {
            rate: 0.6,
            bill: {},
            payment: {},
            transaction: {},
            loading: false,
            init: true,
            countDown: 5,
            ref: this.$route.query.id
        };

    },
    methods: {
        submit() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.countDown = 0;

            // Check Payment

            window.axios['post'](`${window.location.origin}/gift-cards/complete`, {
                ref: this.ref
            }).then((response) => {

                this.init = false;
                if (response.data.success) {
                    this.bill = response.data.body.gift;
                    this.rate = response.data.body.rate || 0.6;
                    this.payment = response.data.body.payment;
                    this.transaction = response.data.body.transaction;
                    if (this.bill.state === 'GENERATING-AIRTIME') {
                        this.countDown = 30;
                        this.startCountDown();
                    }
                }

            }).finally(() => {
                this.loading = false;
            });


        },
        startCountDown() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1;
                    this.startCountDown();
                }, 1000);

            } else {

                if (!this.loading && !this.done) {
                    this.submit();
                }
            }
        },
    },

    mounted() {
        this.submit();
    }
}
</script>

<style scoped>

</style>
